import { createUseStyles } from 'react-jss';
import { mechaColours } from '../mecha_components/mecha_styles';

export const useStyles = createUseStyles({
    formWrapper: {
        width: '100%'
    },
    quotesexpired_startnewquote_container: ({ isInvalid, isXs }) => ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        backgroundColor: mechaColours.backgroundWhite,
        borderRadius: '24px',
        padding: isXs ? '16px' : '32px',
        gap: isInvalid ? '0px' : '24px',
        '& > :nth-child(1)': {
            marginBottom: isInvalid ? '16px' : '0px'
        },
        '& > :nth-child(2)': {
            marginBottom: isInvalid ? '24px' : '0px'
        }
    }),
    quotesexpired_startnewquote_button_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        '@media (max-device-width: 440px)': {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '100%',
            '& button': {
                width: '100%'
            }
        }
    }
});
